<div>
  <option-picker
    [initOption$]="initOption$"
    [label]="optionsLabel"
    [options]="languageOptions"
    [prefix]="optionsPrefix"
    (select)="changeLangTo($event)"
  ></option-picker>
</div>
